import { Component, OnInit } from '@angular/core';
import { Colors } from '../../common/const';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment/moment';
import { environment } from '../../../environments/environment';
import { LAYERS_ID, LAYERS_SQL } from '../layers/constants';
import { MvtService } from '../../common/services/mvt.service';
import { FilterSQL, secondsToTime } from '../../common/utils';
import { HistoricContextService } from 'app/historic/historic-context.service';


@Component({
  selector: 'app-historic-popup',
  templateUrl: './historic-popup.component.html',
  styleUrls: ['./historic-popup.component.scss']
})
export class HistoricPopupComponent implements OnInit {

  colors = Colors;
  properties: any;
  unitLength = environment.unitLength;
  from = null;
  to = null;
  filterUtils = new FilterSQL();

  constructor(
    private translateService: TranslateService,
    private mvtService: MvtService,
    private historicContextService: HistoricContextService
  ) { }

  ngOnInit() {
    this.getDates(this.properties.ntram);
  }

  formatDate(date) {
    return moment.utc(date).local().format('DD/MM/YYYY, HH:mm');
  }

  fromDate() {
    const hour = this.properties.date.fromHour || '00:00';
    return `${('0' + this.properties.date.fromDate.day).slice(-2)}.${(
      '0' + this.properties.date.fromDate.month
    ).slice(-2)}.${this.properties.date.fromDate.year} (${hour})`;
  }

  toDate() {
    const hour = this.properties.date.toHour || '23:59';
    return `${('0' + this.properties.date.toDate.day).slice(-2)}.${(
      '0' + this.properties.date.toDate.month
    ).slice(-2)}.${this.properties.date.toDate.year} (${hour})`;
  }

  getDates(id: number) {
    const p = [];
    const filters = this.historicContextService.getFilters();
    filters.ntram = id;
    const sql = this.filterUtils.filterQuery(LAYERS_SQL[LAYERS_ID.WAZE_BCN_INFO_WINDOW], filters);
    p.push(this.mvtService.getAPIData(sql).toPromise());
    Promise.all(p)
      .then(async (values: any) => {
        this.from = moment(values[0].rows[0].start_ts, 'YYYY-MM-DDThh:mm:ssZ').format('DD/MM/YYYY (HH:mm)');
        this.to = moment(values[0].rows[0].end_ts, 'YYYY-MM-DDThh:mm:ssZ').format('DD/MM/YYYY (HH:mm)');
      })
      .catch((error) => {

      });
  }

  toggleLevelDetail() {
    this.historicContextService.levelDetail$.next(this.properties);
  }

}



// WEBPACK FOOTER //
// ./src/app/historic/historic-popup/historic-popup.component.ts